<template>
  <div class="Settings__body">
    <div class="Settings__body-container">
      <div class="Settings__title">
        Settings
      </div>
      <div class="Settings__inner-container">
        <img class="Settings__profile"
             :src="getUserInfo(user.userId).avatarUrl"
             v-fallback-src="'../../../../static/images/default-user-avatar.jpg'"/>
        <div class="Settings__name">
          {{user.name}}
        </div>
        <div class="Settings__username">
          @{{user.username}}
        </div>
        <div class="Settings__logout-btn" @click="logout">
          logout
        </div>

        <div class="Settings__rows-container">
          <div class="Settings__row">
            <div class="Settings__row-info Settings__account-status"
                 :class="subscription.active ? 'pro' : 'free'">
              <i class="icon-ic_star Settings__row-icon"></i>
              <div class="Settings__row-info-text">
                <span class="Settings__account-status--free">FREE USER</span>
                <span class="Settings__account-status--pro">PRO USER</span>
                <span v-if="subscription.autoRenewing"
                      class="Settings__account-status--pro">
                  Next renewal date: {{ subscription.expireTimeMillis | moment("MMMM DD, YYYY") }}
                </span>
                <span v-else
                      class="Settings__account-status--pro">
                  Expire date: {{ subscription.expireTimeMillis | moment("MMMM DD, YYYY") }}
                </span>
              </div>
            </div>
            <div class="Settings__row-action"
                 @click="toggleUpgradeMenu">
              <span v-if="!subscription.active">UPGRADE FOR FREE*</span>
              <upgrade-dropdown
              :is-open.sync="showUpgradeMenu">
              </upgrade-dropdown>
            </div>
          </div>

          <!--
          ** not implemented yet or will not be implemented **
          <div class="Settings__row">
            <div class="Settings__row-info">
              <i class="icon-ic_link Settings__row-icon Settings__row-icon-link"></i>
              <div class="Settings__row-info-text">
                <span>{{ profileUrl }}</span>
                <span>Conference Url</span>
              </div>
            </div>
            <div class="Settings__row-action"
                 @click="changeUrl">
              CHANGE
            </div>
          </div>
          -->

          <div class="Settings__row">
            <div class="Settings__row-info">
              <i class="icon-ic_lock Settings__row-icon"></i>
              <div class="Settings__row-info-text">
                <span>{{ user.conferencePin }}</span>
                <span>PIN</span>
              </div>
            </div>
            <div class="Settings__row-action"
                 @click="changePin">
              CHANGE
            </div>
          </div>

          <div class="Settings__row">
            <div class="Settings__row-info">
              <i class="icon-ic_help Settings__row-icon"></i>
              <a class="Settings__row-action"
                 href="mailto:kingsconference@joinkingschat.com">
                GET HELP
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="Settings__footer">
      By using the KingsPay platform, you are agreeing to our
      <a class="Settings__footer-link"
         target="_blank"
         href="https://www.kingsch.at/kingsconference/privacy">
        Terms of Service
      </a>,
      <a class="Settings__footer-link"
         target="_blank"
         href="https://www.kingsch.at/kingsconference/privacy">
        Acceptable Use Policy & Privacy Policy
      </a>
    </div>
    <set-conference-url></set-conference-url>
    <set-conference-pin></set-conference-pin>
    <page-title title="KingsConference - Settings"></page-title>
  </div>
</template>

<script>
  import PageTitle from '@/components/common/page-title/page-title';
  import UpgradeDropdown from '@/components/common/upgrade-dropdown/upgrade-dropdown';
  import SetConferenceUrl from './set-conference-url.modal/set-conference-url.modal';
  import SetConferencePin from './set-conference-pin.modal/set-conference-pin.modal';

  export default {
    name: 'settings-tab',
    components: {
      PageTitle,
      UpgradeDropdown,
      SetConferenceUrl,
      SetConferencePin
    },
    data() {
      return {
        showUpgradeMenu: false
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      profileUrl() {
        return `${window.location.origin}/${this.user.username}`;
      },
      subscription() {
        return this.$store.getters.subscription;
      }
    },
    methods: {
      getUserInfo(id) {
        return this.$store.getters.usersInfo[id] || {};
      },
      logout() {
        this.$store.dispatch('logout');
      },
      changeUrl() {
        this.$modal.show(
          'set-conference-url-modal',
          {username: this.user.username}
        );
      },
      changePin() {
        this.$modal.show(
          'set-conference-pin-modal',
          {pin: this.user.conferencePin}
        );
      },
      toggleUpgradeMenu() {
        this.showUpgradeMenu = !this.showUpgradeMenu;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// settings-tab.vue?279363b5